/** When your routing table is too long, you can split it into small modules **/

import Layout from "@/layout";

const adminRouter = [
  {
    path: "/statistics",
    component: Layout,
    redirect: "/statistics/daily",
    name: "statistics",
    meta: {
      title: "数据统计",
      icon: "iconfont icon-setting",
    },
    children: [
      {
        name: "StatisticsDaily",
        path: "statistics-daily",
        component: () => import("@/views/pages/statistics/daily"),
        meta: {
          title: "每日数据统计",
          icon: "iconfont icon-setting",
        },
      },
      {
        name: "JobAnalytics",
        path: "job-analytics",
        component: () => import("@/views/pages/analysics/index"),
        meta: {
          title: "职位数据分析",
          icon: "iconfont icon-setting",
        },
      },
    ],
  },
  {
    path: "/users",
    component: Layout,
    redirect: "/users",
    children: [
      {
        name: "Users",
        path: "",
        component: () => import("@/views/pages/users/index"),
        meta: {
          title: "用户管理",
          icon: "iconfont icon-username",
        },
      },
    ],
  },
  {
    path: "/content",
    component: Layout,
    redirect: "/content/topics",
    name: "content",
    meta: {
      title: "内容管理",
      icon: "iconfont icon-topic",
    },
    children: [
      {
        name: "Workers",
        path: "workers",
        component: () => import("@/views/pages/workers/index"),
        meta: {
          title: "工作",
          icon: "iconfont icon-comments",
        },
      },
      {
        name: "Employs",
        path: "employs",
        component: () => import("@/views/pages/employs/index"),
        meta: {
          title: "求职",
          icon: "iconfont icon-comments",
        },
      },
      {
        name: "MarketTopics",
        path: "market-topics",
        component: () => import("@/views/pages/market/index"),
        meta: {
          title: "Market",
          icon: "iconfont icon-comments",
        },
      },
      {
        name: "Tags",
        path: "tags",
        component: () => import("@/views/pages/tags/index"),
        meta: {
          title: "标签",
          icon: "iconfont icon-tags",
        },
      },
      {
        name: "Articles",
        path: "articles",
        component: () => import("@/views/pages/articles/index"),
        meta: {
          title: "文章",
          icon: "iconfont icon-article",
        },
      },
    ],
  },
  {
    path: "/permission",
    component: Layout,
    redirect: "/permission/postPermission",
    name: "content",
    meta: {
      title: "权限管理",
      icon: "iconfont icon-permission",
    },
    children: [
      {
        name: "postPermission",
        path: "postPermission",
        component: () => import("@/views/pages/permission/postPermission/index"),
        meta: {
          title: "招聘权限",
          icon: "iconfont icon-recruitment",
        },
        children: [
          {
            name: "postCompany",
            path: "postCompany",
            component: () => import("@/views/pages/permission/postPermission/postCompany"),
            meta: {
              title: "公司招聘限制数量",
              icon: "iconfont icon-company",
            },
          },
          {
            name: "postUser",
            path: "postUser",
            component: () => import("@/views/pages/permission/postPermission/postUser"),
            meta: {
              title: "个人招聘限制数量",
              icon: "iconfont icon-user",
            },
          },
          {
            name: "topJob",
            path: "topJob",
            component: () => import("@/views/pages/permission/topJob/index"),
            meta: {
              title: "工作置顶",
              icon: "iconfont icon-user",
            },
          },
        ],
      },
      {
        name: "talentPermissions",
        path: "talentPermissions",
        component: () => import("@/views/pages/permission/talentPermissions/index"),
        meta: {
          title: "人才库权限管理",
          icon: "iconfont icon-talent",
        },
      },
      {
        name: "topJob",
        path: "topJob",
        component: () => import("@/views/pages/permission/topJob/index"),
        meta: {
          title: "置顶展示",
          icon: "iconfont icon-user",
        },
      },

    ],
  },
  {
    path: "/certify",
    component: Layout,
    redirect: "/certify/company-certify",
    name: "certify",
    meta: {
      title: "认证",
      icon: "iconfont icon-setting",
    },
    children: [
      {
        name: "CompanyCertify",
        path: "company-certify",
        component: () => import("@/views/pages/certify/company-certify"),
        meta: {
          title: "公司认证",
          icon: "iconfont icon-setting",
        },
      },
      {
        name: "UserCertify",
        path: "user-certify",
        component: () => import("@/views/pages/certify/user-certify"),
        meta: {
          title: "企业用户认证",
          icon: "iconfont icon-setting",
        },
      },
      {
        name: "EditCompanyCertify",
        path: "editCompany-certify",
        component: () => import("@/views/pages/certify/editCompany-certify"),
        meta: {
          title: "公司信息修改认证",
          icon: "iconfont icon-setting",
        },
      },
    ],
  },
  {
    path: "/setting",
    component: Layout,
    redirect: "/setting/position-setting",
    name: "setting",
    meta: {
      title: "配置",
      icon: "iconfont icon-setting",
    },
    children: [
      {
        name: "PositionTypeSetting",
        path: "position-type-setting",
        component: () => import("@/views/pages/settings/position-type"),
        meta: {
          title: "职位类型",
          icon: "iconfont icon-setting",
        },
      },
      {
        name: "PositionSetting",
        path: "position-setting",
        component: () => import("@/views/pages/settings/position"),
        meta: {
          title: "职位",
          icon: "iconfont icon-setting",
        },
      },
      {
        name: "WhiteList",
        path: "white-list",
        component: () => import("@/views/pages/settings/white-list"),
        meta: {
          title: "白名单",
          icon: "iconfont icon-setting",
        },
      },
      {
        name: "MarketCategorySetting",
        path: "market-category-setting",
        component: () => import("@/views/pages/market/categories"),
        meta: {
          title: "Market 一级分类",
          icon: "iconfont icon-setting",
        },
      },
      {
        name: "MarketSubcategorySetting",
        path: "market-subcategory-setting",
        component: () => import("@/views/pages/market/subcategories"),
        meta: {
          title: "Market 二级分类",
          icon: "iconfont icon-setting",
        },
      },
    ],
  },
];
export default adminRouter;
